import { MarketType } from '@img-arena/consoles-api-golf-pricing'
import { golfPricingApi } from '@/service/golfPricingApi'

import { createBaseTableStore } from '../table'
import { FetchApiResponse } from '../table/table.types'

export const fetchApi = async (): Promise<FetchApiResponse<MarketType>> => {
  const { data } = await golfPricingApi.endpoints.prerequisites.getMarketTypes()

  return {
    content: data,
    totalElements: data.length
  }
}

export const useMarketTypesStore = createBaseTableStore({
  storeName: 'DDE Golf Pricing - Market types',
  fetchApi
})
